import { useState, useEffect } from 'react';
import { Game } from '../types';

const STORAGE_KEY = 'recentGames';
const MAX_RECENT_GAMES = 10;

export function useRecentGames() {
  const [recentGames, setRecentGames] = useState<Game[]>([]);

  // 從 localStorage 讀取資料
  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      setRecentGames(JSON.parse(stored));
    }
  }, []);

  // 添加新遊戲到最近玩過列表
  const addRecentGame = (game: Game) => {
    setRecentGames(prev => {
      // 移除重複的遊戲
      const filtered = prev.filter(g => g.id !== game.id);
      // 新遊戲放在最前面
      const updated = [game, ...filtered].slice(0, MAX_RECENT_GAMES);
      // 儲存到 localStorage
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return updated;
    });
  };

  return { recentGames, addRecentGame };
} 